import React from "react";
import "./styles.css";

function Cards({ list, type, onBrandSelect, onModelSelect }) {
  const brandImages = {
    Apple: "https://cdnpublic.quieromac.com/brands/iPhone",
    Huawei: "https://cdnpublic.quieromac.com/brands/Huawei",
    Infinix: "https://cdnpublic.quieromac.com/brands/Infinix",
    Motorola: "https://cdnpublic.quieromac.com/brands/Motorola",
    Oppo: "https://cdnpublic.quieromac.com/brands/Oppo",
    Samsung: "https://cdnpublic.quieromac.com/brands/Samsung",
    Vivo: "https://cdnpublic.quieromac.com/brands/Vivo",
    Xiaomi: "https://cdnpublic.quieromac.com/brands/Xiaomi",
    TCL: "https://cdnpublic.quieromac.com/brands/TCL",
    Nokia: "https://cdnpublic.quieromac.com/brands/Nokia",
    Hyundai: "https://cdnpublic.quieromac.com/brands/Hyundai",
    Honor: "https://cdnpublic.quieromac.com/brands/Honor",
    ZTE: "https://cdnpublic.quieromac.com/brands/ZTE",
    Tecno: "https://cdnpublic.quieromac.com/brands/Tecno",
    default: "https://cdnpublic.quieromac.com/brands/default",
  };

  const handleClick = (item) => {
    if (type === "brand" && onBrandSelect) {
      onBrandSelect(item);
    } else if (type === "models" && onModelSelect) {
      onModelSelect(item);
    }
  };

  return (
    <section className="cards">
      {list.map((item, index) => {
        const imageUrl = brandImages[item] || brandImages.default;
        return (
          <button
            key={index}
            className={`card-button ${type === "models" ? "model" : ""}`}
            onClick={() => handleClick(item)}
          >
            <img
              src={item.image || imageUrl}
              alt={item}
              className="card-image"
            />
            {type === "models" && <p>{item.name}</p>}
          </button>
        );
      })}
    </section>
  );
}

export default Cards;
